<template>
  <div class="pandabar-container">
    <div v-if="shout" class="pandabar-shout bar">
      <a :href="shout.urls.fuic" class="shout-inner" target="_blank" @click="triggerShout">
        <img v-if="shout.image" class="icn" :src="shout.image" :alt="shout.title">
        <div v-else class="icn icon-wrapper">
          <img src="https://storage.googleapis.com/panda-public/megaphone.svg" :alt="shout.title">
        </div>
        <div class="shout-details">
          <h4>{{ shout.title }}</h4>
          <h5>{{ shout.description }}</h5>
        </div>
      </a>
      <img class="imp" :src="shout.imp.fuic">
      <a class="shout-close tooltip" data-tooltip="Hide today's shout" @click="hideShout">
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.14768 0.196911C0.885134 -0.0656371 0.459459 -0.065637 0.196911 0.196911C-0.065637 0.459459 -0.065637 0.885134 0.196911 1.14768L3.04931 4.00009L0.197061 6.85234C-0.0654873 7.11489 -0.0654872 7.54056 0.197061 7.80311C0.459609 8.06566 0.885284 8.06566 1.14783 7.80311L4.00009 4.95086L6.85231 7.80308C7.11486 8.06563 7.54053 8.06563 7.80308 7.80308C8.06563 7.54053 8.06563 7.11486 7.80308 6.85231L4.95086 4.00009L7.80323 1.14771C8.06578 0.885163 8.06578 0.459488 7.80323 0.19694C7.54068 -0.065608 7.11501 -0.065608 6.85246 0.19694L4.00009 3.04931L1.14768 0.196911Z" fill="white" />
        </svg>
      </a>
      <a class="shout-self tooltip" :href="shout.promotedUrl.fuic" :data-tooltip="shout.tooltipText" target="_blank">
        <span>Promoted</span>
        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="1">
            <path d="M5 9.5C7.20914 9.5 9 7.70914 9 5.5C9 3.29086 7.20914 1.5 5 1.5C2.79086 1.5 1 3.29086 1 5.5C1 7.70914 2.79086 9.5 5 9.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.83594 4.29996C3.92998 4.03263 4.1156 3.8072 4.35992 3.66361C4.60424 3.52002 4.8915 3.46753 5.17081 3.51544C5.45012 3.56335 5.70346 3.70857 5.88597 3.92537C6.06847 4.14217 6.16836 4.41657 6.16794 4.69996C6.16794 5.49996 4.96794 5.89996 4.96794 5.89996" stroke="#0E2660" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 7.5H5.004" stroke="#0E2660" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>

      </a>
    </div>
    <div class="pandabar-campaigns bar">
      <a @click="linkClick(index, s)" :href="s.url.panda" target="_blank" class="animated fadeIn" :key="s._id" v-for="(s, index) in sponsors">
        {{randomEmoji()}} {{s.short_title || "Title Here"}}
        <img class="imim" v-if="s.trackingImage" :src="s.trackingImage" alt="" />
      </a>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { sendActivity, fetchPandaShout, fetchPandaSponsors } from '@/api';

export default {
  name: 'PandaBar',
  components: {},
  data() {
    return {
      sponsors: [],
      shout: null
    };
  },
  mounted() {
    this.fetchSponsors();
    this.fetchShout();
  },
  methods: {
    async fetchSponsors() {
      const sponsors = await fetchPandaSponsors();
      this.sponsors = sponsors.newsCampaigns;
      this.trackShow();
    },
    async fetchShout() {
      const shout = await fetchPandaShout();
      const hiddenShoutId = localStorage.getItem('fuic.shout.id');

      if (!shout || !shout.enabled || hiddenShoutId === shout.id) return;

      this.shout = shout
    },
    trigger(url) {
      const req = new XMLHttpRequest();
      req.open('GET', url);
      req.send();
    },
    hideShout() {
      localStorage.setItem('fuic.shout.id', this.shout.id);
      this.trigger(this.shout.urls.close);
      this.shout = null;
    },
    triggerShout() {
      this.trigger(this.shout.url);
    },
    trackShow() {
      this.sponsors.forEach((sponsor, index) => {
        sendActivity('FUIC_TEXT_AD_SHOW', `${sponsor._id}:${index}`);
      });
    },
    randomEmoji() {
      return _.sample(['🙌', '☝️', '✌️', '👉', '🖐', '🤙', '👍', '✊', '👋']);
    },
    linkClick(index, sponsor){
      this.$ga.event('link-click',index);
      sendActivity('FUIC_TEXT_AD_CLICK', `${sponsor._id}:${index}`);
    }

  }
};
</script>
<style lang="scss" scoped>
.pandabar-container {
  display: flex;
  width: 100%;
  margin-bottom: 40px;
}

.pandabar-shout {
  position: relative;
  color: white !important;
  margin-right: 20px;

  + div {
    margin-left: 20px;
  }

  a {
    color: inherit;
  }

  .imp {
    width: 1px;
    height: 1px;
    opacity: 0;
    visibility: hidden;
    position: absolute;
  }

  .shout-inner {
    display: flex;
    padding-right: 12px;

    .icn {
      flex: 0 0 33px;
      height: 33px;
      margin-right: 12px;
      border-radius: 2px;
    }

    .icon-wrapper {
      background-color: rgba(255,255,255,0.12);
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        position: relative;
        right: 1px;
      }
    }

    .shout-details {
      flex: 1;

      h4 {
        margin-top: 2px;
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        margin-bottom: 4px;
      }

      h5 {
        font-size: 12px;
        font-weight: 600;
      }
    }
  }

  .shout-close {
    display: flex;
    position: absolute;
    padding: 4px;
    top: 4px;
    right: 4px;
    opacity: 0.7;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }

  .shout-self {
    position: absolute;
    display: flex;
    align-items: center;
    right: 8px;
    bottom: 8px;
    font-size: 10px;
    line-height: 11px;
    font-weight: 700;
    opacity: 0.6;
    cursor: pointer;

    svg {
      margin-left: 6px;
    }

    &:hover {
      opacity: 1;
    }
  }
}

.bar {
  padding: 12px;
  min-height: 56px;
  align-items: center;
  box-sizing: border-box;
  background: #0c2461;
  border-radius: 4px;
  flex: 1;
}

.pandabar-campaigns {
  display: flex;
  justify-content: space-around;
  a {
    color: #fff;
    transition: all 0.2s;
    &:after {
      content: "→";
      opacity: 0;
      position: relative;
      left: 0px;
      top: 1px;
      margin-left: 0px;
      transition: all 0.2s;
    }
    &:hover{
      &:after{
        opacity: 1;
        left: 6px;
      }
    }
    &:active{
      transform: scale(0.95);
    }
  }

  .imim {
    position: absolute;
    width: 1px;
    height: 1px;
    visibility: hidden;
    opacity: 0;
  }
}

@media (max-width: 600px) {
  .pandabar-shout {
    margin-right: 0;
  }

  .pandabar-campaigns {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PandaBar.vue